<template>
    <div class="text-left">
        <div class="row" v-if="showForm">
            <div class="col-md-9 col-xl-7" >
                <div class="label-form-div">
                    <div class="form-label-heading mb-4 pb-1">Cutline</div>
                    <div class="form-check mb-2" v-for="maskKey in getMaskTypes">
                        <input class="form-check-input" type="radio" :id="'mask_radio_'+maskKey" :value="maskKey" v-model="selected_mask_type">
                        <label class="form-check-label" :for="'mask_radio_'+maskKey">
                            <img v-if="maskTypeImages[maskKey]" class="mr-2" style="width: 2.125rem" :src="'/themes/storefront/public/images/icons/'+maskTypeImages[maskKey]">
                            {{maskTranslations[maskKey] ? maskTranslations[maskKey] : ''}}
                        </label>
                    </div>
                </div>
            </div>

            <div class="col-md-9 col-xl-5 mg-5 mt-md-0" >
                <div class="label-form-div">
                    <div class="form-label-heading mb-4 pb-1">Sizes</div>
                    <div class="form-check mb-2" v-for="sizeKey in getSizes">
                        <input class="form-check-input" type="radio" :id="'size_radio_'+sizeKey" :value="sizeKey" v-model="selected_size">
                        <label class="form-check-label" :for="'size_radio_'+sizeKey">
                            {{formatDimension(sizeKey)}}
                        </label>
                    </div>
                    <div class="form-check mb-2">
                        <label @click.prevent="openModal" class="form-check-label">
                            Custom size
                        </label>
                    </div>
                </div>
            </div>

            <div class="col-md-9 col-xl-6 mg-5 mt-xl-0" >
                <div class="label-form-div">
                    <div class="form-label-heading mb-4 pb-1">Quantity</div>
                    <div class="form-check mb-2" v-for="amountKey in getAmounts">
                        <input class="form-check-input" type="radio" :id="'amounts_radio_'+amountKey" :value="amountKey" v-model="selected_amount">
                        <label class="form-check-label" :for="'amounts_radio_'+amountKey">
                            {{amountKey}} <span class="float-right" v-html="getAmount(amountKey)"></span>
                        </label>
                    </div>
                </div>
            </div>

            <div class="col-md-9 col-xl-7 mg-5" >
                <div class="label-form-div">
                    <div class="form-label-heading mb-4 pb-1">Material</div>
                    <div class="form-check mb-2" v-for="materialKey in getMaterials">
                        <input class="form-check-input" type="radio" :id="'material_radio_'+materialKey" :value="materialKey" v-model="selected_material">
                        <label class="form-check-label" :for="'material_radio_'+materialKey">
                            {{materialTranslations[materialKey] ? materialTranslations[materialKey] : ''}}
                        </label>
                    </div>
                </div>
            </div>

            <div class="col-xl-11 mg-5">
                <div class="label-form-div">
                    <div class="form-label-heading mb-4 pb-1">Add file</div>

                    <div v-if="filesToggle">
                        <file-upload
                            name="file"
                            :media-options="mediaOptions"
                            @files="updateFiles"
                            @onError="notifyError"
                            ref="fileUpload"
                            multiple
                        ></file-upload>

                        <div class="mt-3" style="color: red;" v-if="errorMessage !== ''" v-html="errorMessage"></div>
                    </div>
                </div>

                <div class="didnt-find-message text-center text-sm-left mt-3 pt-2 mb-4 pb-2">
                    Don’t see a size or quantity listed? <a :href="route('contact.create')">Contact us</a>
                </div>

                <div v-if="addToCartEnabled">
                    <button type="button" class="btn btn-primary w-100 text-uppercase" @click="addToCart" :disabled="loading">Add to cart</button>
                </div>
            </div>
        </div>
        <div v-if="showForm">
            <modal ref="custom-size-modal" :centered="true">
                <template v-slot:modal-title>
                    CUSTOM SIZE
                </template>

                <div class="d-flex flex-column gap-6 mt-6">
                    <p class="fs-4 fw-600 text-center">Don’t see a size or quantity listed?</p>
                    <a :href="route('contact.create')" class="btn btn-primary btn-medium">
                        Contact us
                    </a>
                </div>
            </modal>
            <portal-target name="modal-destination" multiple></portal-target>
        </div>
    </div>
</template>

<script>
    import FileUpload from "./FileUpload";
    import ProductCardMixin from "../../mixins/ProductCardMixin";
    import vue from 'vue';
    import {formatPrice, formatSizeString} from "../../functions";

    export default {
        name: "FullLabelForm",
        components: {FileUpload},
        props: ['priceInfo', 'mediaOptions', 'labelId'],
        mixins: [
            ProductCardMixin
        ],
        data() {
            return {
                showForm: false,

                selected_material: 'vinyl',
                selected_size: '2x2',
                selected_amount: '100',
                selected_mask_type: 'square',

                errorMessage: '',
                files: [],
                filesToggle: true,
                loading:false,
                priceData: {},
                selectableMaskTypes: [
                    'square',
                    'circle',
                    'rounded_corners',
                    'die_cut_small',
                ],
                maskTypeImages: {
                    'circle': 'circle-icon@2x.png',
                    'die_cut_small': 'die-cut-icon@2x.png',
                    'square': 'square-icon@2x.png',
                    'rounded_corners': 'rounded-corners-icon@2x.png',
                },
                maskTranslations: {
                    'circle': 'Circle',
                    'die_cut_small': 'Die cut',
                    'square': 'Square / Rectangle',
                    'rounded_corners': 'Rounded corners',
                },
                materialTranslations: {
                    'vinyl': 'Vinyl',
                    'clear_sticker': 'Clear sticker',
                    'holographic': 'Holographic',
                    'craft_sticker': 'Craft paper',
                    'prismatic': 'Prismatic',
                    'gliter': 'Gliter',
                },
                maskData: {
                    square: {
                        type: 'square',
                        matches: 'square', // key to compare to in price table
                    },
                    circle: {
                        type: 'circle',
                        matches: 'circle',
                    },
                    rounded_corners: {
                        type: 'rounded_corners',
                        matches: 'rounded_corners',
                        radius: 20,
                    },
                    die_cut_small: {
                        type: 'die_cut_small',
                        matches: 'die_cut',
                        stroke_width: 8,
                    },
                    die_cut_medium: {
                        type: 'die_cut_medium',
                        matches: 'die_cut',
                        stroke_width: 20,
                    },
                    die_cut_large: {
                        type: 'die_cut_large',
                        matches: 'die_cut',
                        stroke_width: 45,
                    }
                },
            };
        },
        mounted() {
            vue.set(this, 'priceData', this.priceInfo)
            this.priceData = this.priceInfo;
            /*this.sizeKeys = Object.keys(this.sizeInfo);
            this.selected_size = this.sizeKeys[0] ? this.sizeKeys[0] : null;
            if (this.selected_size !== null) {
                this.selectAmount();
            }
            this.showForm = this.sizeKeys.length > 0;*/
            this.showForm = Object.keys(this.priceInfo).length > 0;
            this.getPrice;
        },
        computed: {
            addToCartEnabled() {
                let result = false;
                if (this.files.length > 0) {
                    result = true;
                    if (this.files[0].loading) {
                        result = false;
                    }
                }
                if (this.selected_amount === null || this.selected_size === null) {
                    result = false;
                }
                return result;
            },
            getMaterials() {
                return Object.keys(this.priceData ?? {});
            },
            getMaskTypes() {
                let app = this;
                const materialData = this.priceData?.[this.selected_material] ?? {};
                const mask_types = Object.keys(materialData);


                if (mask_types.includes('any')) {
                    return this.selectableMaskTypes.sort();
                } else {
                    // Price table has an "any" mask type
                    if(!mask_types.includes(app.maskData[this.selected_mask_type].matches)) {
                        Object.keys(app.maskData).forEach(type => {
                            if (mask_types.includes(app.maskData[type].matches)) {
                                app.selected_mask_type = type;
                            }
                        });
                    }
                }

                let dieCutIndex = mask_types.indexOf('die_cut');
                if ( dieCutIndex !== -1){
                    mask_types[dieCutIndex] = 'die_cut_small';
                }

                return mask_types.sort();
            },
            getSizes() {
                const materialData = this.priceData?.[this.selected_material] ?? {};
                const maskTypeData = {...(materialData[this.getMaskTypeSelector()] || {}), ...(materialData['any'] || {})};
                const widths = Object.keys(maskTypeData);
                if (!widths.includes(this.selected_size)) {
                    this.selected_size = widths[widths.length - 1];
                }
                return widths;
            },
            getAmounts() {
                const materialData = this.priceData?.[this.selected_material] ?? {};
                const maskTypeData = {...(materialData[this.getMaskTypeSelector()] || {}), ...(materialData['any'] || {})};
                const heightData = maskTypeData[this.selected_size] || {};
                const amounts =  Object.keys(heightData);
                if (!amounts.includes(this.selected_amount)) {
                    this.selected_amount = amounts[0] || this.selected_amount;
                }
                return amounts;
            },
            getAmountInfo() {
                const materialData = this.priceData?.[this.selected_material] ?? {};
                const maskTypeData = {...(materialData[this.getMaskTypeSelector()] || {}), ...(materialData['any'] || {})};
                const amounts = maskTypeData[this.selected_size] || {};
                return amounts;
            },
            getPrice() {
                const materialData = this.priceData?.[this.selected_material] ?? {};
                const maskTypeData = {...(materialData[this.getMaskTypeSelector()] || {}), ...(materialData['any'] || {})};
                const heightData = maskTypeData[this.selected_size] || {};
                return heightData[parseInt(this.selected_amount)] || '';
            },
        },
        methods: {
            getAmount(key) {
                return formatPrice(this.getAmountInfo[key]);
            },
            getMaskTypeSelector() {
                let mask_type = this.selected_mask_type;
                if (['die_cut_small', 'die_cut_medium', 'die_cut_large'].includes(mask_type)) {
                    return 'die_cut';
                }
                return mask_type;
            },
            updateFiles(data) {
                this.files = data;
            },
            notifyError(message) {
                this.errorMessage = message;
            },
            addToCart() {
                let app = this;
                let fileData = [];
                app.loading = true;
                this.files.forEach(file => {
                    fileData.push({
                        name: file.file_name,
                        data: file.encoded_file,
                    });
                });
                this.addToCartCustomSticker(
                    fileData,
                    app.selected_mask_type,
                    app.selected_material,
                    app.selected_size,
                    app.selected_amount
                ).then(() => {
                    app.filesToggle = false;
                    vue.nextTick(() => {
                        app.filesToggle = true;
                        app.loading = false;
                    });
                }).catch(() => {
                    app.loading = false;
                });
            },
            openModal() {
                this.$refs['custom-size-modal'].openModal();
            },
            formatDimension(dimension) {
                return formatSizeString(dimension);
            }
        }
    }
</script>

<style lang="scss" scoped>
    .mg-5 {
        margin-top: 2rem;
    }
</style>
